import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";

const useFileData = (id) => {
  const { getFilesData } = useMail();
  const { getFileId, getFileData } = useLightBox();
  const fileData = getFileData()
    ? getFileData()
    : id
    ? getFilesData()[id]
    : getFilesData()[getFileId()];
  return fileData;
};

export default useFileData;
